import {
	GET_DIARIO_PAZIENTE_FAIL,
	GET_DIARIO_PAZIENTE_START, GET_DIARIO_PAZIENTE_SUCCESS
} from "./actions/ActionTypes";

export const initPazienteState = () => {
	return {
		diarioPaziente: {},
		loadingGetDiarioPaziente: true,
		errorGetDiarioPaziente: "",
	}
}

export const PAZIENTE_INITIAL_STATE = {}

export const PazienteReducer = (state = PAZIENTE_INITIAL_STATE, action) => {
	switch (action.type) {
		case GET_DIARIO_PAZIENTE_START:
			return {
				...state,
				diarioPaziente: [],
				loadingGetDiarioPaziente: true,
				errorGetDiarioPaziente: "",
			}
		case GET_DIARIO_PAZIENTE_SUCCESS:
			return {
				...state,
				diarioPaziente: action.payload,
				loadingGetDiarioPaziente: false,
				errorGetDiarioPaziente: "",
			}
		case GET_DIARIO_PAZIENTE_FAIL:
			return {
				...state,
				diarioPaziente: [],
				loadingGetDiarioPaziente: false,
				errorGetDiarioPaziente: action.error,
			}
		
		default:
			return state;
	}
}
